<template>
  <div class="confirm-image">
    <img :src="fileSrc" class="img-fluid" :class="{ is_pdf: pdfCheck }" />
    <div>{{ fileName }}</div>
  </div>
</template>

<script>
import { getFileSrcToBase64, getFileType } from "@/utils/ImageHelper";
export default {
  name: "ConfirmImage",
  props: {
    fileName: { type: String, default: "" },
    fileData: { type: String, default: "" },
  },
  computed: {
    fileSrc: function () {
      return getFileSrcToBase64(this.fileData, this.fileName);
    },
    pdfCheck() {
      return getFileType(this.fileName) === "pdf";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/stylesheets/styles";
.confirm-image {
  background-color: $light;
  border: 1px solid $secondary;
  padding: 20px;
  text-align: center;
  word-break: break-all;
  @include mq-up(md) {
    padding: 40px;
  }
  img {
    border: 1px solid $secondary;
    margin-bottom: 10px;
  }
  .is_pdf {
    max-width: 188px;
    border: none;
  }
}
</style>
